import { AddressSearchResult } from '../../models/services/api/getAddresses';

/**
 *
 * THIS HAS TAKEN FROM: https://github.com/domgen/b2bce-campaigning-service/blob/8a5cebe22a79fc20d35db9d285e9ae8d0137c1b3/src/v2/utils/addressQueryResponseBuilder.ts#L29
 * Returns a structured address
 *
 * - it explodes the sub buildings into an array
 *
 *  Scenarios to handle once found matching address
 *
 *  1. if existing address in the results, the subBuilding exists and is an array and the new address the subBuilding exists and is an array
 *  2. if the existing address in the subBuilding exists and is an array and the new address has subBuilding
 *
 *  ASSUMPTIONS
 *
 *  - The address returned form IPS api passed into this function will always be unique , no chance of dupe record with different id
 *  - Building with with sub buildings will always appear as 2 records one with the root building and it's id and postcode.
 *    The other record will be the comma separated strings with part of the postcode and the posted to used for the address is off the building record
 *  - Addresses that will be in the results with the sub buildings as an array will have been created by this method and nothing else
 *

 *
 * @param addresses
 * @returns
 */

export const addressQueryResponseBuilder = (addresses: AddressSearchResult[]) => {
  // We know in the response that if the building has sub buildings that both items will be returned
  // The first item will be the building it will have the same addressLine1, streetNumber city and region. the postal code and the id's will be different

  const addressWithSubBuilding = addresses.filter((address) => address.subBuilding);
  return addresses
    .filter((a) => !a.subBuilding)
    .map((a) => {
      const matching = addressWithSubBuilding.find(
        (i: AddressSearchResult) =>
          i.addressLine1 === a.addressLine1 &&
          i.streetNumber === a.streetNumber &&
          i.city === a.city &&
          i.street === a.street,
      );
      if (matching) {
        // do merge
        const ids = matching.id.split(',');
        const subBuildings = (matching.subBuilding as string).split(',');

        return {
          ...a,
          totalUnits: subBuildings.length,
          subBuilding: subBuildings.map((sub, index) => ({
            id: ids[index],
            sub,
            address: `${a.addressLine1} ${sub}, ${a.city}, ${a.regionOrStateCode} ${a.postalCode}`,
          })),
        };
      } else {
        return a;
      }
    });
};
